export default {
  verdusProxy: 'verdusproxy',
};
